"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

const TIMER_COUNT = 60;
const DEFAULT_INTERVAL = 1000; // 倒计时以秒计

class CountDown {
  constructor(options) {
    (0, _defineProperty2.default)(this, "options", void 0);
    (0, _defineProperty2.default)(this, "intervalId", void 0);
    (0, _defineProperty2.default)(this, "start", () => {
      const _this$options = this.options,
            _this$options$startSe = _this$options.startSec,
            startSec = _this$options$startSe === void 0 ? TIMER_COUNT : _this$options$startSe,
            onCountChange = _this$options.onCountChange,
            interval = _this$options.interval;
      const startCountingTime = Date.now();
      let remainSec = startSec;
      this.clear();
      this.intervalId = setInterval(() => {
        const hasTakeTime = Math.floor((Date.now() - startCountingTime) / 1000);
        const newRemainSec = startSec - hasTakeTime;

        if (remainSec > 1) {
          if (typeof onCountChange === 'function' && remainSec !== newRemainSec) {
            onCountChange(newRemainSec);
          }
        } else if (this.intervalId) {
          // 倒计时完毕停止
          this.clear();
        }
      }, interval);
    });
    this.options = _objectSpread({
      startSec: (options === null || options === void 0 ? void 0 : options.startSec) || TIMER_COUNT,
      interval: (options === null || options === void 0 ? void 0 : options.interval) || DEFAULT_INTERVAL
    }, options);
  }

  // 清除倒计时
  clear() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

}

exports.default = CountDown;